module.exports = __webpack_public_path__ + "img/safe_tool_2.6be1e923.jpg";